<template>
  <div class="container">
    <span>指</span>
    <span>北</span>
    <span>i</span>
    <span>s</span>
    <span>s</span>
    <span>u</span>
    <span>e</span>
    <span>s</span>
  </div>
</template>

<script>
export default {
  name: "welcome"
}
</script>

<style scoped>
.container{
  width: 100%;
  height: 55vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #ffffff;
}
span{
  font-family: fira code;
  font-size: 10em;
  filter: blur(2px);
  color: #fff;
  animation: animate 2.5s linear infinite;
}
span:nth-child(1){
  animation-delay: 0s;
}
span:nth-child(2){
  animation-delay: 0.25s;
}
span:nth-child(3){
  animation-delay: 0.5s;
}
span:nth-child(4){
  animation-delay: 0.75s;
}
span:nth-child(5){
  animation-delay: 1s;
}
span:nth-child(6){
  animation-delay: 1.25s;
}
span:nth-child(7){
  animation-delay: 1.5s;
}
span:nth-child(8){
  animation-delay: 1.75s;
}
span:nth-child(9){
  animation-delay: 2s;
}
@keyframes animate {
  0%, 100% {
    filter: blur(2px);
    color: #fff;
    text-shadow: 0 0 10px #277ac9,
    0 0 20px #1e90ff,
    0 0 30px #1e90ff,
    0 0 40px #1e90ff,
    0 0 100px #1e90ff,
    0 0 200px #1e90ff,
    0 0 300px #1e90ff,
    0 0 400px #1e90ff;
  }
  5%, 95% {
    filter: blur(0px);
    color: #666;
    text-shadow: none;
  }
}
</style>

